import { IconButton, PlusIcon } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type WhatsappTemplateListEmptyStateProps = {
  variant: 'global' | 'filtered';
  onCreate?: () => void;
};

export const WhatsappTemplateListEmptyState: FC<WhatsappTemplateListEmptyStateProps> = ({ variant, onCreate }) => {
  const { t } = useTranslation('campaign');

  if (variant === 'filtered') {
    return (
      <div className='rounded-2xl border border-dashed border-secondary-border bg-white p-5 text-sm text-secondary-600'>
        {t('whatsappTemplates.noFilteredTemplatesFound')}
      </div>
    );
  }

  return (
    <div className='flex flex-col items-center gap-4 rounded-2xl border border-dashed border-secondary-border bg-white p-8 text-center'>
      <div className='space-y-1'>
        <h3 className='text-base font-semibold text-slate-900'>{t('whatsappTemplates.noTemplatesFound')}</h3>
      </div>
      {onCreate ? (
        <IconButton
          leadingIcon={<PlusIcon className='size-5 text-white-100' />}
          className='inline-flex justify-center'
          onClick={onCreate}
          text={t('whatsappTemplates.createButton')}
        />
      ) : null}
    </div>
  );
};
